<template>
  <v-app>
    <v-app-bar
      app
      color="appbar"
      clipped-left
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        v-if="isMobile"
      />

      <v-spacer />

      <v-img
        alt="Sterling Lyon Pediatrics"
        title="Sterling Lyon Pediatrics"
        contain
        src="/banner.jpg"
        max-width="85%"
        max-height="95%"
      />

      <v-spacer />

      <template v-slot:extension v-if="!isMobile">
        <v-tabs
          centered
          color="text"
          background-color="transparent"
        >
          <v-tab v-for="(item,i) in links" :key="i" :to="item.path">
            {{item.name}}
          </v-tab>
        </v-tabs>
      </template>

    </v-app-bar>

    <v-navigation-drawer
      app
      clipped
      v-model="drawer"
      v-if="isMobile"
    >
      <v-list>
        <v-list-item v-for="(item,i) in links" :key="i" :to="item.path">
          {{item.name}}
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <v-container style="max-width: 1000px;" class="pt-8">
        <router-view :links="links" :isMobile="isMobile" />
      </v-container>
    </v-content>

    <v-footer>
      <v-col cols="12" class="text-center">
        <span>Appt. Monday - Friday 8 AM to 5 PM</span>
        <span v-if="$vuetify.breakpoint.smAndUp" class="px-2">|</span>
        <br v-else />
        <span>Phone Lines 9 AM to 5 PM (204) 942-0949</span>
        <span v-if="$vuetify.breakpoint.lgAndUp" class="px-2">|</span>
        <br v-else />
        <span>Fax: (204) 943-2666</span>
        <span v-if="$vuetify.breakpoint.smAndUp" class="px-2">|</span>
        <br v-else />
        <span>Suite 401-1020 Lorimer Blvd</span>
      </v-col>
    </v-footer>

  </v-app>
</template>

<script>
import { routes } from './router/index';

export default {
  name: 'App',

  data: () => ({
    routes,
    drawer: false,
  }),

  computed: {
    links() {
      return this.routes.filter(route => route.name !== '404' && !route.deprecated);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
